// Teams and projects of a workspace, in the Admin group.
import { UsersIcon } from "lucide-react";
import { registerNav } from "../../app/registry/nav";
import { routes } from "../context";

registerNav({
  id: "scopes",
  group: "admin",
  labelKey: "scopes.nav",
  icon: UsersIcon,
  to: ({ params }) => (params.workspace ? routes.scopes(params.workspace) : null),
  order: 10,
});
